import axios from 'axios';
import {IAuth} from "../@types";

const SSO_API_URL = process.env.REACT_APP_API_URL_SSO_AUTHENTICATION as string;

const api = axios.create({
  headers: { 'Access-Control-Allow-Origin': '*' },
  baseURL: SSO_API_URL,
});

export type TLoginConsole = {
  companyId: number;
  name: string;
  url: string;
  id: number;
  createdAtDt: string;
  createdByDs: string;
  enabled: boolean;
}

export type TSSOLoginResponse = {
  statusCode: number;
  success: boolean;
  data: IAuth
}

export type TSSOLoginParams = {
  email: string;
  password: string;
}

export const login = async (params: TSSOLoginParams): Promise<TSSOLoginResponse> => {

  try {
    const { data } = await api.post('/', params);
    return data;
  } catch (error) {
    console.log(error)
  }
}

export default api;